var LP_EN = /^en\b/i.test(document.documentElement.lang || '');
(function () {
  'use strict';

  const HCAPTCHA_SITEKEY = 'f06e6c50-85a8-45c8-87d0-21a2b65856fe';
  const HCAPTCHA_SRC = 'https://js.hcaptcha.com/1/api.js?render=explicit&recaptchacompat=off';

  let modal = null;
  let form = null;
  let emailInput = null;
  let tagInput = null;
  let captchaInput = null;
  let submitButton = null;
  let submitText = null;
  let submitLoading = null;
  let successEl = null;
  let errorEl = null;
  let productTitleDisplay = null;
  let variantTitleDisplay = null;
  let captchaContainer = null;
  let captchaWidgetId = null;
  let hcaptchaLoadPromise = null;
  let currentVariantId = '';
  let currentProductId = '';

  function loadHcaptcha() {
    if (window.hcaptcha) return Promise.resolve(window.hcaptcha);
    if (hcaptchaLoadPromise) return hcaptchaLoadPromise;
    hcaptchaLoadPromise = new Promise((resolve, reject) => {
      const cbName = '__lapatia_hcap_' + Math.random().toString(36).slice(2);
      const tag = HCAPTCHA_SRC + '&onload=' + cbName;
      window[cbName] = function () {
        delete window[cbName];
        resolve(window.hcaptcha);
      };
      const s = document.createElement('script');
      s.src = tag;
      s.async = true;
      s.defer = true;
      s.onerror = function () {
        reject(new Error('hCaptcha load failed'));
      };
      document.body.appendChild(s);
    });
    return hcaptchaLoadPromise;
  }

  function ensureCaptchaWidget() {
    if (captchaWidgetId !== null) return Promise.resolve(captchaWidgetId);
    return loadHcaptcha().then((hc) => {
      if (!captchaContainer || !form) return null;
      captchaWidgetId = hc.render(captchaContainer, {
        sitekey: HCAPTCHA_SITEKEY,
        size: 'invisible',
      });
      return captchaWidgetId;
    });
  }

  function init() {
    modal = document.getElementById('back-in-stock-modal');
    if (!modal) return;

    form = modal.querySelector('#back-in-stock-form');
    emailInput = modal.querySelector('#back-in-stock-email');
    tagInput = modal.querySelector('[data-back-in-stock-tag]');
    submitButton = modal.querySelector('.back-in-stock-modal__submit');
    submitText = modal.querySelector('.back-in-stock-modal__submit-text');
    submitLoading = modal.querySelector('.back-in-stock-modal__submit-loading');
    successEl = modal.querySelector('[data-back-in-stock-success]');
    errorEl = modal.querySelector('[data-back-in-stock-error]');
    productTitleDisplay = modal.querySelector('[data-back-in-stock-product-title]');
    variantTitleDisplay = modal.querySelector('[data-back-in-stock-variant-title]');

    if (form) {
      form.setAttribute('data-nocaptcha', 'true');

      captchaContainer = document.createElement('div');
      captchaContainer.className = 'back-in-stock-modal__captcha';
      form.appendChild(captchaContainer);

      captchaInput = form.querySelector('input[name="h-captcha-response"]');
      if (!captchaInput) {
        captchaInput = document.createElement('input');
        captchaInput.type = 'hidden';
        captchaInput.name = 'h-captcha-response';
        form.appendChild(captchaInput);
      }

      form.addEventListener('submit', killSubmit, true);
      form.addEventListener('submit', handleSubmit);
    }
    if (submitButton) submitButton.addEventListener('click', handleSubmit);

    document.addEventListener('click', handleDocumentClick);
    modal.addEventListener('click', handleBackdropClick);
  }

  function killSubmit(event) {
    event.preventDefault();
    event.stopPropagation();
  }

  function handleDocumentClick(event) {
    const trigger = event.target.closest('[data-back-in-stock-trigger]');
    if (trigger) {
      event.preventDefault();
      event.stopPropagation();
      openModal(trigger);
      return;
    }
    const closer = event.target.closest('[data-back-in-stock-close]');
    if (closer && modal.contains(closer)) {
      event.preventDefault();
      closeModal();
    }
  }

  function handleBackdropClick(event) {
    if (event.target === modal) {
      closeModal();
    }
  }

  function openModal(trigger) {
    resetState();
    currentVariantId = trigger.getAttribute('data-variant-id') || '';
    currentProductId = trigger.getAttribute('data-product-id') || '';
    const productTitle = trigger.getAttribute('data-product-title') || '';
    const variantTitle = trigger.getAttribute('data-variant-title') || '';

    if (tagInput) tagInput.value = currentProductId ? `back-in-stock-product-${currentProductId}` : '';
    if (productTitleDisplay) productTitleDisplay.textContent = productTitle;
    if (variantTitleDisplay) {
      variantTitleDisplay.textContent =
        variantTitle && variantTitle !== 'Default Title' ? variantTitle : '';
    }

    if (typeof modal.showModal === 'function') {
      try { modal.showModal(); } catch (_) { modal.setAttribute('open', ''); }
    } else {
      modal.setAttribute('open', '');
    }
    setTimeout(() => emailInput && emailInput.focus(), 50);

    ensureCaptchaWidget().catch(() => {});
  }

  function closeModal() {
    if (typeof modal.close === 'function') {
      try { modal.close(); } catch (_) { modal.removeAttribute('open'); }
    } else {
      modal.removeAttribute('open');
    }
  }

  function resetState() {
    if (successEl) successEl.hidden = true;
    if (errorEl) {
      errorEl.hidden = true;
      errorEl.textContent = '';
    }
    if (form) form.hidden = false;
    if (submitButton) submitButton.hidden = false;
    setLoading(false);
    if (emailInput) {
      emailInput.disabled = false;
      emailInput.value = '';
    }
    if (captchaInput) captchaInput.value = '';
    if (captchaWidgetId !== null && window.hcaptcha) {
      try { window.hcaptcha.reset(captchaWidgetId); } catch (_) {}
    }
  }

  function setLoading(isLoading) {
    if (!submitButton) return;
    submitButton.disabled = isLoading;
    if (submitText) submitText.hidden = isLoading;
    if (submitLoading) submitLoading.hidden = !isLoading;
  }

  function showError(message) {
    if (!errorEl) return;
    errorEl.textContent = message;
    errorEl.hidden = false;
  }

  function showSuccess() {
    if (successEl) successEl.hidden = false;
    if (errorEl) errorEl.hidden = true;
    if (submitButton) submitButton.hidden = true;
    if (emailInput) emailInput.disabled = true;
  }

  async function handleSubmit(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    if (errorEl) errorEl.hidden = true;

    const email = (emailInput.value || '').trim();
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      showError((LP_EN ? 'Please enter a valid email address.' : 'Lütfen geçerli bir e-posta adresi girin.'));
      emailInput.focus();
      return;
    }

    if (!currentVariantId || !currentProductId) {
      showError((LP_EN ? 'Could not load product details. Please refresh the page and try again.' : 'Ürün bilgisi alınamadı. Lütfen sayfayı yenileyip tekrar deneyin.'));
      return;
    }

    setLoading(true);
    try {
      const widgetId = await ensureCaptchaWidget();
      let token = '';
      if (widgetId !== null && window.hcaptcha) {
        const result = await window.hcaptcha.execute(widgetId, { async: true });
        token = (result && result.response) || '';
      }
      if (!token) {
        showError((LP_EN ? 'Verification failed. Please try again.' : 'Doğrulama başarısız oldu. Lütfen tekrar deneyin.'));
        setLoading(false);
        return;
      }
      if (captchaInput) captchaInput.value = token;

      const endpoint = (form.action || '/contact').split('#')[0];
      const response = await fetch(endpoint, {
        method: 'POST',
        body: new FormData(form),
        credentials: 'same-origin',
        redirect: 'follow',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });

      if (response.status >= 200 && response.status < 400) {
        showSuccess();
      } else {
        showError((LP_EN ? 'Submission failed (code ' + response.status + '). Please try again.' : 'Gönderim başarısız (kod ' + response.status + '). Lütfen tekrar deneyin.'));
        setLoading(false);
      }
    } catch (err) {
      showError((LP_EN ? 'Connection error. Please try again.' : 'Bağlantı hatası. Lütfen tekrar deneyin.'));
      setLoading(false);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
